import PricingContent from './PricingContent'
export default PricingContent
